type MainTicket = { name: string; quantity: number }
type ItemTicket = Pick<BundleItemTicket, 'id' | 'name'>

// The legacy bundle rule: when every ticket of the booking has one with the same name on the item, the quantities are
// copied by name. When any of them doesn't, the first ticket of the item gets all of them.
export function matchTicketsByName(mainTickets: MainTicket[], itemTickets: ItemTicket[]): Record<string, number> {
  const quantities: Record<string, number> = Object.fromEntries(itemTickets.map((ticket) => [ticket.id, 0]))

  if (!itemTickets.length) return quantities

  const selectedTickets = mainTickets.filter((ticket) => ticket.quantity > 0)
  const matchOf = (mainTicket: MainTicket) => itemTickets.find((ticket) => ticket.name === mainTicket.name)

  if (selectedTickets.every((mainTicket) => matchOf(mainTicket))) {
    for (const mainTicket of selectedTickets) {
      const { id } = matchOf(mainTicket)!

      quantities[id] = (quantities[id] ?? 0) + mainTicket.quantity
    }
  } else {
    quantities[itemTickets[0]!.id] = selectedTickets.reduce((total, ticket) => total + ticket.quantity, 0)
  }

  return quantities
}
